/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./i18n-group-item.vue?vue&type=template&id=528c8bfd&scoped=true&"
import script from "./i18n-group-item.vue?vue&type=script&lang=js&"
export * from "./i18n-group-item.vue?vue&type=script&lang=js&"
import style0 from "./i18n-group-item.vue?vue&type=style&index=0&id=528c8bfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c8bfd",
  null
  
)

export default component.exports